export default "__VITE_ASSET__8ad3c6cc__"